module.exports = __webpack_public_path__ + "media/src/images/abouts/items/stores/jins-a737fdaa6da907777062f00f0072a28a.jpg";